import { useEffect } from "react";
import { useLocation } from "react-router";
import { useShowSnackbar } from "./useShowSnackbar";
import {
  eraseDisplayNotification,
  eraseGlobalNotification,
  getDisplayNotification,
  getGlobalNotification
} from "services/storage";

export const useRouteChange = () => {
  const location = useLocation();
  const { removeNotification, addNotification } = useShowSnackbar();

  useEffect(() => {
    window.scrollTo(0, 0);

    const shouldRemoveNotification = !getDisplayNotification();
    if (shouldRemoveNotification) {
      removeNotification();
      eraseDisplayNotification();
      return;
    }

    const globalNotification = getGlobalNotification();
    if (globalNotification) {
      addNotification(globalNotification);
      eraseGlobalNotification();
    }
  }, [location, removeNotification, addNotification]);

  return null;
};
